import { render, staticRenderFns } from "./disc.block.pug?vue&type=template&id=c154beda&scoped=true&lang=pug&external"
import script from "./disc.block.ts?vue&type=script&lang=ts&external"
export * from "./disc.block.ts?vue&type=script&lang=ts&external"
import style0 from "./disc.block.sass?vue&type=style&index=0&id=c154beda&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c154beda",
  null
  
)

export default component.exports